<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
    mounted () {
    // if the urls: url/en || url/en/ || url/pt || url/pt/
    var currentUrl = window.location.pathname;
    if (currentUrl == "/en" || currentUrl == "/pt" || currentUrl == "/en/" || currentUrl == "/pt/") {
      this.$router.push({name: 'Home'}) 
    };
  },

}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .c-header
  {
    background-color: #2b86c5;
  }
  .c-header-nav-link
  {
    color: #fff !important;
  }
  .c-subheader
  {
    display: none;
  }
  .c-sidebar-brand > svg
  {
    display: none !important;
  }
.c-sidebar {
    color: #fff;
    background: #2b86c5;
}
// border css for vue-editor "Validate both translations"
.quillWrapper.is-invalid .ql-toolbar,
.quillWrapper.is-invalid #quill-container
{
  border-color: red;
}

@media only screen and (max-width: 767px) {
  .main-content {
      flex-direction: column;
  }
}

.quillWrapper.is-invalid .ql-snow.ql-toolbar,
.quillWrapper.is-invalid .ql-snow.ql-container
{
  border-color: #e55353;
}

input[type='checkbox']
{
  width: 35px;
  height: 35px;
  cursor: pointer;
  margin-top: 0;
}

.vue-tags-input
{
  max-width: unset !important;
}

th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #2b86c5;
}

.ti-tag
{
  background-color: #2b86c5 !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* Global classes */
.disabled > input,
.disabled > .dropdown
{
  pointer-events: none;
  opacity: 0.7;
}

.gap-1
{
  gap: 1rem;
}

.cursor-pointer
{
  cursor: pointer;
}

.pointer-none
{
  pointer-events: none;
}
</style>
